import {css} from '@emotion/css';
import {Breakpoints, mq} from '../../../styles/js/mixins';
import {columnHalf, columnStackableMobile, containerStackMobile} from '../../../styles/js/mixins/layout';
import {colours, spacing} from '../../../styles/js/variables';

const styles = {
  homepageHero: css`
    label: homepageHero;
    ${containerStackMobile}
    color: ${colours.font.BLACK};

    ${mq(Breakpoints.TABLET)} {
      align-items: center;
    }
  `,
  content: css`
    label: homepageHero__content;
    ${columnStackableMobile(spacing.M)}

    ${mq(Breakpoints.TABLET)} {
      ${columnHalf}
      padding-right: ${spacing.L};
    }
  `,
  description: css`
    label: homepageHero__description;
    margin-bottom: ${spacing.L};

    ${mq(Breakpoints.TABLET)} {
      margin-bottom: ${spacing.M};
    }
  `,
  supportingInfo: css`
    label: homepageHero__supportingInfo;
    position: relative;
    align-self: center;

    ${mq(Breakpoints.TABLET)} {
      ${columnHalf}
      align-self: flex-start;
      margin-left: auto;
    }
  `,
  image: css`
    label: homepageHero__image;
    display: block;
    width: 100%;
    max-width: 40.5rem;
    margin-right: ${spacing.XS};
    margin-left: auto;

    ${mq(Breakpoints.TABLET)} {
      max-width: none;
    }
  `,
  trustPilot: css`
    label: homepageHero__trustPilot;
    position: absolute;
    top: 2rem;
    right: 1rem;
    width: 17.5rem;
    max-height: 11.5rem;
    padding: ${spacing.XXS} 0 ${spacing.XXS} 1.4rem;
    background-color: ${colours.general.WHITE};
    border-radius: 2px;
    filter: drop-shadow(0.1rem 0.4rem 1rem rgba(0, 0, 0, 0.2));

    ${mq(Breakpoints.TABLET)} {
      right: 0;
      width: 25.5rem;
      max-height: 13rem;
    }

    // size widget to container
    > .trustpilot-widget {
      width: 100%;
      padding: 0;
    }
  `,
};

export default styles;
